import React from "react";
import { TableBusinessBills } from "../../components";

const BusinessBills = () => {
  return (
    <div className="m-4" data-aos="zoom-in-down">
      <TableBusinessBills />
    </div>
  );
};

export default BusinessBills;
